import type { RunMode } from '@bda/shared';

const dateFmt = new Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeStyle: 'short' });

export const formatDate = (iso: string | null | undefined): string => (iso ? dateFmt.format(new Date(iso)) : '-');

export function formatDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '-';
  const s = Math.round(ms / 1000);
  return s < 60 ? `${s}s` : `${Math.floor(s / 60)}m ${s % 60}s`;
}

export const versionLabel = (v: number | 'DRAFT' | null | undefined): string =>
  v === 'DRAFT' ? 'Draft' : v === null || v === undefined ? '-' : `v${v}`;

export const isoDay = (d: Date): string => d.toISOString().slice(0, 10);
export const daysAgo = (n: number, from = new Date()): string => isoDay(new Date(from.getTime() - n * 86_400_000));

/** What kind of run a history row is (design "Other pages": a mode label next to the blueprint name). */
const RUN_MODE_LABELS: Record<RunMode, string> = {
  custom: 'Blueprint',
  suggest: 'Suggestions',
  preview: 'Preview',
  set: 'Set',
  setPreview: 'Set preview',
  packetSuggest: 'Set proposal',
};
export const runModeLabel = (mode: RunMode): string => RUN_MODE_LABELS[mode];
